var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',[_c('div',{staticClass:"relative bg-gray-000",class:_vm.isBleed && 'pb-ar-' + _vm.aspectRatio.replace(':', 'x')},[_vm._t("media")],2),_c('media-caption',_vm._b({},'media-caption',_vm.$attrs,false),[_vm._t("caption")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }